(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _socialToolbar = __webpack_require__(6);
	
	var _socialToolbar2 = _interopRequireDefault(_socialToolbar);
	
	var _stickyKit = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Logger.debug('script layout loaded');
	
	/** get main vars */
	var app = Voonto.getInstance();
	var vocUserPath = app.lookup('vocento.config.nibara').vocUserPath;
	if (vocUserPath === undefined) {
	    throw 'vocUserPath path in config is empty';
	}
	var libPath = app.lookup('vocento.config.nibara').libPath;
	if (libPath === undefined) {
	    throw 'nibara libPath config is empty';
	}
	
	/** querystring vars */
	function getUrlVars() {
	    var vars = [],
	        hash = void 0;
	    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
	    for (var i = 0; i < hashes.length; i++) {
	        hash = hashes[i].split('=');
	        vars.push(hash[0]);
	        vars[hash[0]] = hash[1];
	    }
	    return vars;
	}
	
	/** btn up */
	Voonto.$('.boton.subir').click(function () {
	    var target = Voonto.$('[name=' + Voonto.$(this).attr('id') + ']');
	    if (target.length) {
	        Voonto.$('html,body').animate({
	            scrollTop: target.offset().top
	        }, 2000);
	        return false;
	    }
	});
	
	/** Menu */
	if (Voonto.is.mobile() || Voonto.is.tablet()) {
	    Voonto.$('[data-abre-navegacion]').click(function () {
	        Voonto.$('.navegacion').stop().animate({ left: '0px' }, 350, 'linear');
	    });
	    Voonto.$('[data-cierra-navegacion]').click(function () {
	        var width = Voonto.$('.navegacion').css('width');
	        Voonto.$('.navegacion').stop().animate({ left: '-' + width }, 350, 'linear');
	    });
	    Voonto.$('[data-abre-siguiente]').click(function () {
	        Voonto.$(this).next().slideToggle();
	        Voonto.$(this).toggleClass('rotado');
	    });
	
	    if (Voonto.is.tablet()) {
	        app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(function () {
	            Voonto.$('[data-sticky]').stick_in_parent({
	                offset_top: 20,
	                spacer: false
	            });
	        });
	    }
	
	    // Modulo breaking-news
	    Voonto.SocialToolbar = new _socialToolbar2.default();
	    var $urgente = Voonto.$('.urgente-teinteresa');
	    if ($urgente.length > 0) {
	        var $cerrarUrgente = $urgente.find('.cerrar');
	        var type = $cerrarUrgente.data('type');
	        if (type === 'urgente') {
	            if (compruebaCookie()) {
	                Logger.info('[Breaking News] urgente hide. Existe cookie');
	                $urgente.hide();
	            } else {
	                Logger.info('[Breaking News] urgente show. No existe cookie');
	                $urgente.show();
	            }
	        } else {
	            Logger.info('[Breaking News] urgente show. Existe urgente multiple');
	            $urgente.show();
	        }
	
	        $cerrarUrgente.click(function () {
	            $urgente.hide();
	            Voonto.SocialToolbar.enable();
	
	            var type = $cerrarUrgente.data('type');
	            if (type === 'te-interesa') {
	                return false;
	            }
	
	            var src = 'BreakingNews-ABC';
	            var content = 'Breaking News - ABC';
	            createCookie(src, content);
	        });
	    }
	
	    Voonto.$('.noticia').click(function () {
	        Logger.info('[Breaking News] click noticia');
	        var type = Voonto.$(this).data('type');
	        if (type === 'urgente') {
	            var src = 'BreakingNews-ABC';
	            var content = 'Breaking News - ABC';
	            createCookie(src, content);
	        }
	
	        Logger.info('[Breaking News] type: ', type);
	
	        var href = Voonto.$(this).data('href');
	        if (typeof href !== 'undefined') {
	            Logger.info('[Breaking News] href: ', href);
	            window.location.href = href;
	        }
	    });
	} else {
	    if (Voonto.$('.segundo-nivel').length) {
	        Voonto.$('.titulo-seccion').css({
	            'top': '-112px',
	            'opacity': 1
	        });
	    } else {
	        Voonto.$('.titulo-seccion').css('opacity', 1);
	    }
	    Voonto.$('[data-desplegable-navegacion]').on({
	        'mouseenter': function mouseenter() {
	            Voonto.$(this).find('ul').show();
	        },
	        'mouseleave': function mouseleave() {
	            Voonto.$(this).find('ul').hide();
	        }
	    });
	
	    app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(function () {
	        Voonto.$('[data-sticky]').stick_in_parent({
	            offset_top: 20,
	            spacer: false
	        });
	    });
	
	    (0, _stickyKit.initSticky)();
	
	    Voonto.$(window).on('resize', function () {
	        Logger.info('[Sticky] Window Resize');
	        (0, _stickyKit.recalcSticky)();
	    });
	
	    Voonto.$('[data-voc-vam]').on('vam:viewable', function () {
	        Logger.info('[Sticky] Banner', Voonto.$(this), 'viewable');
	        (0, _stickyKit.recalcSticky)();
	    });
	
	    app.on('layout:init-sticky', function () {
	        (0, _stickyKit.initSticky)();
	    });
	
	    app.on('layout:recalc-sticky', function () {
	        (0, _stickyKit.recalcSticky)();
	    });
	}
	
	Voonto.$('[data-cerrar]').click(function () {
	    checkCookieLaw();
	    Voonto.$(this).parent().hide();
	});
	
	/** VocUser */
	var vocUserVersion = app.lookup('vocento.config.nibara').vocUserVersion || '201701010101';
	Logger.info('Loading vocuser version: ' + vocUserVersion);
	app.load(vocUserPath + '/vocento-vocuser-preloader.js?v=' + vocUserVersion);
	
	/** Vam */
	var vamPath = app.lookup('vocento.config.nibara').vamPath;
	if (vamPath === undefined) {
	    throw 'nibara vamPath config is empty';
	}
	var vamUrl = vamPath + "/vam.js";
	Logger.info('Loading vam version: ' + vamUrl);
	app.load(vamUrl);
	
	/** create cookie function */
	function createCookie(src) {
	    var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    Logger.info('[Breaking News] Creo una cookie para un tiempo de vida de 1 hora.');
	    // Creo una cookie para un tiempo de vida de 1 hora.
	    var date = new Date();
	    var minutes = 60;
	    date.setTime(date.getTime() + minutes * 60 * 1000);
	
	    var cookieParameters = { path: '/', expires: date };
	    Cookies(src, content, cookieParameters);
	}
	
	function compruebaCookie() {
	    Logger.info('[Breaking News] compruebaCookie');
	    var src = 'BreakingNews-ABC';
	    Logger.info('[Breaking News] src: ' + src);
	    return !(Cookies(src) === null || Cookies(src) === "" || Cookies(src) === "null" || typeof Cookies(src) === 'undefined');
	}
	
	/** header search widget */
	Voonto.$(".buscador").on("submit", function (e) {
	    var str = Voonto.$(this).find('input').val();
	    if (str.length > 0) {
	        str = kebabCase(str);
	        if (window.location.href.indexOf('lavozdigital.es') > -1) {
	            str += '.html';
	        }
	        var action = Voonto.$(this).attr('action') + str;
	        Logger.debug('action: ', action);
	        Voonto.$(this).attr('action', action);
	    }
	    this.submit();
	});
	
	function kebabCase(str) {
	    var result = void 0;
	
	    // Convierte mayus. camelCase a kebab-case.
	    result = str.replace(/([a-z][A-Z])/g, function (match) {
	        return match.substr(0, 1) + '-' + match.substr(1, 1).toLowerCase();
	    });
	
	    result = result.toLowerCase();
	
	    // Convierte no caracteres alfanumericos en '+'
	    result = result.replace(/[^-a-z0-9áéíóúàèìòùüÜñÑ]{1}/g, '+');
	
	    return result;
	}
	
	/** fake functions to legacy rendered news */
	window.lzld = function () {
	    return false;
	};
	
	window.ads = {
	    printAds: function printAds(params) {
	        Logger.debug('ads blocked');
	        return false;
	    }
	
	    /** tracking sticky mobile buttons */
	};if (Voonto.is.mobile() || Voonto.is.tablet()) {
	    Voonto.$('.publi-sticky.sticky > .botones.cerrar').on('click', function () {
	        TagManager.ready.then(function () {
	            try {
	                /** dejamos desactivado el track hasta que nos confirmen que solo hace falta el atributo en el elmento */
	                //  TagManager.set({idCampana: 'cerrarsticky'}).track();
	            } catch (e) {
	                Logger.error('Error to try track button ', e);
	            }
	        });
	
	        Voonto.SocialToolbar.enable();
	    });
	
	    Voonto.$('.urgente-teinteresa.sticky > .botones.cerrar').on('click', function () {
	        TagManager.ready.then(function () {
	            try {
	                /** dejamos desactivado el track hasta que nos confirmen que solo hace falta el atributo en el elmento */
	                //  TagManager.set({idCampana: 'cerrarsticky'}).track();
	            } catch (e) {
	                Logger.error('Error to try track button ', e);
	            }
	        });
	    });
	}
	
	/** tracking up to top button */
	Voonto.$('.boton.subir.suave').on('click', function () {
	    TagManager.ready.then(function () {
	        try {
	            /** dejamos desactivado el track hasta que nos confirmen que solo hace falta el atributo en el elmento */
	            //  TagManager.set({idCampana: 'subirheader'}).track();
	        } catch (e) {
	            Logger.error('Error to try track button ', e);
	        }
	    });
	});
	
	/** cookieLaw */
	checkCookieLaw();
	window.cookieLayerVisto = function () {
	    Logger.info('[Cookie Layer] Compruebo cookie aviso de Política de Cookies.');
	    checkCookieLaw();
	};
	
	function createCookieLaw() {
	    if (document.cookie.indexOf("cookie_20170731") === -1) {
	        var cookieName = 'cookie_20170731';
	        Logger.info('[Cookie Layer] createCookieLaw: ' + cookieName);
	        var cookieDate = new Date();
	        cookieDate.setFullYear(cookieDate.getFullYear() + 1);
	        document.cookie = cookieName + '=visited; expires=' + cookieDate.toGMTString() + ';';
	        Voonto.$('.capa-cookies').fadeOut().hide();
	    }
	}
	
	function checkCookieLaw() {
	    Logger.info('[Cookie Layer] checkCookieLaw');
	    if (document.cookie.indexOf("cookie_20170731") === -1) {
	        var cookieDiv = $('.capa-cookies');
	        cookieDiv.show();
	
	        Voonto.$(window).one('mousewheel', function (e) {
	            Logger.info('[Cookie Layer] create cookie mousewheel');
	            createCookieLaw();
	        });
	
	        Voonto.$(window).one('scroll', function (e) {
	            Logger.info('[Cookie Layer] create cookie scroll');
	            createCookieLaw();
	        });
	
	        Voonto.$(window).one('touchmove', function (e) {
	            Logger.info('[Cookie Layer] create cookie touchmove');
	            createCookieLaw();
	        });
	
	        cookieDiv.click(function () {
	            Logger.info('[Cookie Layer] create cookie click');
	            createCookieLaw();
	        });
	    }
	}
	
	/** Push notifications */
	compruebaCookieWebPush();
	function compruebaCookieWebPush() {
	    Logger.info('[Cookie Notification Push] compruebaCookieWebPush');
	    var domain = window.location.hostname;
	    var nPunto = domain.indexOf(".") + 1;
	    var src = "wp_" + domain.substring(nPunto);
	    src = src.replace('.', '_');
	    Logger.info('[Cookie Notification Push] src: ' + src);
	    if (Cookies(src) === null || Cookies(src) === "" || Cookies(src) === "null" || typeof Cookies(src) === 'undefined') {
	        ActivarWebPush();
	    }
	}
	
	function crearCookieWebPush() {
	    Logger.info('[Cookie Notification Push] crearCookieWebPush');
	    var domain = window.location.hostname;
	    var nPunto = domain.indexOf(".") + 1;
	    var src = "wp_" + domain.substring(nPunto);
	    src = src.replace('.', '_');
	    var cookieParameters = { domain: domain, path: '/', expires: 365 };
	    Cookies(src, "OK", cookieParameters);
	}
	
	window.AbrirWebPush = function (pushUrl) {
	    Logger.info('[Cookie Notification Push] AbrirWebPush');
	    crearCookieWebPush();
	    Voonto.$(".contentwebpush").hide();
	    window.open(pushUrl, "", "width=600,height=700");
	};
	
	window.CerrarWebPush = function () {
	    Logger.info('[Cookie Notification Push] CerrarWebPush');
	    crearCookieWebPush();
	    Voonto.$(".contentwebpush").hide();
	};
	
	function isNotNotification() {
	    var ua = navigator.userAgent || navigator.vendor || window.opera;
	    return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1 || ua.indexOf("iPhone") > -1 || ua.indexOf("iPad") > -1 || ua.indexOf("Apple Computer") > -1;
	}
	
	function ActivarWebPush() {
	    Logger.info('[Cookie Notification Push] ActivarWebPush');
	    if (isNotNotification() === false) {
	        var config = {
	            medio: window.vocento.config.nibara.media,
	            imagen: '//www.abc.es/webpush/img/logo_abc.png',
	            alt: 'ABC',
	            texto: 'abc.es',
	            pushUrl: '//push.abc.es'
	        };
	
	        if (config.medio === 'sevilla') {
	            config.imagen = '//sevilla.abc.es/webpush/img/logo-sevilla.png';
	            config.alt = 'ABC de Sevilla';
	            config.texto = 'abcdesevilla.es';
	            config.pushUrl = '//push-sevilla.abc.es';
	        } else if (config.medio === 'lavoz') {
	            config.imagen = '//www.lavozdigital.es/webpush/img/logo-lavozdigital.png';
	            config.alt = 'La voz de Cádiz';
	            config.texto = 'lavozdigital.es';
	            config.pushUrl = '//push.lavozdigital.es';
	        }
	
	        var html = ' \
	            <div class="contentwebpush"> \
	                <img class="logowebpush lzld" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="' + config.imagen + '" alt="' + config.alt + '"> \
	                <div class="holawebpush"> \
	                <h3>¡Hola!</h3> \
	                <p>¿Quieres que ' + config.texto + ' te mantenga informado en todo momento?</p> \
	                <fieldset class="ap-customradiowrapwebpush"> \
	                    <a class="btn-leftwebpush" href="javascript:void(0)" onclick="window.ns_onclick(this,\'\',\'name=push-permitir&amp;ns_site=abc-es\',\'hidden\');AbrirWebPush(\'' + config.pushUrl + '\');return false;">Permitir</a> \
	                    <a class="btn-rightwebpush" href="javascript:void(0)" onclick="window.ns_onclick(this,\'\',\'name=push-bloquear&amp;ns_site=abc-es\',\'hidden\');CerrarWebPush();return false;">No,gracias</a> \
	                </fieldset> \
	                </div> \
	            </div>';
	        Voonto.$("body").append(html);
	        app.trigger('scroll');
	    }
	}
	
	/** image lazyload */
	Voonto.lazyLoad = new LazyLoad({
	    elements_selector: ".lzld",
	    data_src: "src"
	});
	
	Voonto.$('.lzld-scroll').on('click', function (ev) {
	    Voonto.lazyLoad.handleScroll();
	});
	
	/** akamai debug */
	if (getUrlVars()['akamai_debug'] === '1') {
	    Voonto.$('body').prepend('<div style="border: solid 1px red;padding: 21px;">x-akamai-device-characteristics: ' + vocento.tracking.root.akamai_device + '</div>');
	}

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.recalBody = recalBody;
	exports.initSticky = initSticky;
	exports.recalcSticky = recalcSticky;
	var app = Voonto.getInstance();
	var libPath = app.lookup('vocento.config.nibara').libPath;
	if (libPath === undefined) {
	    throw 'nibara libPath config is empty';
	}
	
	var cargaSticky = false,
	    tamBody = 0,
	    tamColC = Voonto.$('.mas-contenido-articulo').height();
	;
	function recalBody() {
	    if (typeof Voonto.$('.hueco-imagen-principal ').height() === 'number') {
	        tamBody = Voonto.$('.hueco-imagen-principal ').height() + Voonto.$('.cuerpo-texto').height();
	    } else {
	        tamBody = Voonto.$('.cuerpo-texto').height();
	    }
	    Logger.info('[Sticky] recalBody tamBody: ' + tamBody + ' tamColC: ' + tamColC);
	}
	
	function initSticky() {
	    Logger.info('[Sticky] Function initSticky');
	    recalBody();
	    if (tamBody >= tamColC && !cargaSticky) {
	        app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(function () {
	            Logger.info('[Sticky] initSticky');
	            Voonto.$('[data-sticky-spacer]').each(function (i, e) {
	                var spacer = Voonto.$(e).parent().data('spacer');
	                if (typeof spacer !== 'undefined') {
	                    Logger.info('[Sticky] spacer: .', spacer);
	                    Voonto.$(e).stick_in_parent({
	                        offset_top: 20,
	                        spacer: '.' + spacer
	                    });
	                }
	            });
	            cargaSticky = true;
	        });
	    }
	    Logger.info('[Sticky] CargaSticky', cargaSticky);
	}
	
	function recalcSticky() {
	    Logger.info('[Sticky] Function recalcSticky');
	    recalBody();
	    if (tamBody >= tamColC) {
	        if (cargaSticky) {
	            Logger.info('[Sticky] recalcSticky');
	            Voonto.$('[data-sticky-spacer]').parent().attr('style', '');
	            Voonto.$(document.body).trigger('sticky_kit:recalc');
	        } else {
	            initSticky();
	        }
	    }
	}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var lastScrollTop = 0,
	    overlayPosition = parseInt(Voonto.$('.cuerpo-texto p:first').offset().top),
	    $toolbar = Voonto.$('.herramientas.fija'),
	    $document = Voonto.$(document);
	
	function handleScroll() {
	    Logger.info('SocialToolbar handleScroll');
	    var redesSticky = void 0;
	    if (redesSticky = document.querySelector('.herramientas.fija')) {
	        var redesFijo = function redesFijo() {
	            redesSticky.classList.add('redesVisible');
	            return 'fijo';
	        };
	
	        var redesRelativo = function redesRelativo() {
	            redesSticky.classList.remove('redesVisible');
	            return 'relativo';
	        };
	
	        var redes = redesSticky.nextElementSibling;
	        var estadoRedes = redes.getBoundingClientRect().bottom > 0 ? redesRelativo() : redesFijo();
	        var delay = false;
	        var marcador = void 0;
	        if (marcador = document.querySelector('.marcador')) ;
	        setTimeout(function () {
	            document.addEventListener('scroll', function () {
	                if (delay) return;
	                if (redes.getBoundingClientRect().bottom <= (marcador ? marcador.offsetHeight : 0) && estadoRedes === 'relativo') {
	                    estadoRedes = redesFijo();
	                }
	                if (redes.getBoundingClientRect().bottom > (marcador ? marcador.offsetHeight : 0) && estadoRedes === 'fijo') {
	                    estadoRedes = redesRelativo();
	                }
	                delay = true;
	                setTimeout(function () {
	                    delay = false;
	                }, 50);
	            });
	        }, 500);
	    }
	}
	
	var SocialToolbar = function () {
	    function SocialToolbar(form) {
	        _classCallCheck(this, SocialToolbar);
	
	        this.hasToolbar = $toolbar.length !== 0;
	        this.isEnabled = false;
	    }
	
	    _createClass(SocialToolbar, [{
	        key: 'enable',
	        value: function enable() {
	            Logger.info('SocialToolbar enable. isEnabled: ' + this.isEnabled);
	            if (!this.isEnabled) {
	                $document.on('scroll', handleScroll);
	                this.isEnabled = true;
	            }
	        }
	    }, {
	        key: 'disable',
	        value: function disable() {
	            Logger.info('SocialToolbar disable. isEnabled: ' + this.isEnabled);
	            if (this.isEnabled) {
	                $document.off('scroll', handleScroll);
	                this.isEnabled = false;
	                var redesSticky = document.querySelector('.herramientas.fija');
	                redesSticky.classList.remove('redesVisible');
	                /* if ($toolbar.is(':visible')) {
	                    $toolbar.fadeOut(250);
	                 }*/
	            }
	        }
	    }]);
	
	    return SocialToolbar;
	}();
	
	exports.default = SocialToolbar;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// layout-script.js